import { Link } from "react-router-dom";
import { AlertCircle, Info, MicOff, RotateCw, Wallet, X } from "lucide-react";
import { cn } from "@/lib/utils";

const ICON = { permission: MicOff, credits: Wallet, info: Info, warn: AlertCircle, error: AlertCircle };

export function VoiceNotice({ notice, onRetry, onDismiss }) {
  if (!notice) return null;
  const Icon = ICON[notice.kind] || AlertCircle;
  const loud = notice.kind === "error" || notice.kind === "permission" || notice.kind === "credits";
  return (
    <div role="alert" className={cn("flex items-start gap-3 rounded-2xl border px-4 py-3.5", loud ? "border-rose-400/25 bg-rose-500/[0.07]" : "border-white/[0.08] bg-ink-850")} data-testid="voice-notice">
      <Icon className={cn("mt-0.5 h-4 w-4 shrink-0", loud ? "text-rose-300" : "text-zinc-400")} strokeWidth={1.8} />
      <div className="min-w-0 flex-1">
        <p className="text-sm text-zinc-200" data-testid="voice-notice-message">{notice.message}</p>
        <div className="mt-2.5 flex flex-wrap gap-2 empty:hidden">
          {notice.retry && (
            <button type="button" onClick={onRetry} className="inline-flex h-8 items-center gap-1.5 rounded-full bg-white px-3.5 text-[13px] font-medium text-ink-950 transition-transform active:scale-95" data-testid="voice-notice-retry">
              <RotateCw className="h-3.5 w-3.5" /> Try again
            </button>
          )}
          {notice.kind === "credits" && (
            <Link to="/plan" className="inline-flex h-8 items-center rounded-full bg-white px-3.5 text-[13px] font-medium text-ink-950" data-testid="voice-notice-add-credits">
              Add credits
            </Link>
          )}
        </div>
      </div>
      <button type="button" onClick={onDismiss} aria-label="Dismiss" className="rounded-full p-1 text-zinc-500 transition-colors hover:text-white" data-testid="voice-notice-dismiss">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
